// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectionCheckbox_SelectionCheckbox__6yncU {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/ReportConfigurator/SelectionCheckbox.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AACF","sourcesContent":[".SelectionCheckbox {\n  display: flex;\n  align-items: center;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SelectionCheckbox": `SelectionCheckbox_SelectionCheckbox__6yncU`
};
export default ___CSS_LOADER_EXPORT___;
